import { CircularProgress } from '@mui/material';

import { IndicatorContainer } from './TrlLoadingIndicator.styles';

export const TrlLoadingIndicator = () => (
  <IndicatorContainer id="loadingIndicatorContainer">
    <CircularProgress color="inherit" />
  </IndicatorContainer>
);
